import graphql from 'babel-plugin-relay/macro'
import React, {Suspense} from 'react'
import {useFragment} from 'react-relay'
import githubScopingSearchFilterMenuQuery, {

} from '../__generated__/GitHubScopingSearchFilterMenuQuery.graphql'


import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import GitHubScopingSearchFilterMenu from './GitHubScopingSearchFilterMenu'
import MockFieldList from './MockFieldList'







const GitHubScopingSearchFilterMenuRoot = (props) => {
  const {menuProps, teamId, meetingRef} = props
  const meeting = useFragment(
    graphql`
      fragment GitHubScopingSearchFilterMenuRoot_meeting on PokerMeeting {
        id
      }
    `,
    meetingRef
  )
  const {id: meetingId} = meeting
  const queryRef = useQueryLoaderNow(
    githubScopingSearchFilterMenuQuery,
    {meetingId, teamId}
  )

  if (!meetingId) return null

  return (
    React.createElement(Suspense, { fallback: React.createElement(MockFieldList, null ),}
      , queryRef && React.createElement(GitHubScopingSearchFilterMenu, { queryRef: queryRef, menuProps: menuProps,} )
    )
  )
}

export default GitHubScopingSearchFilterMenuRoot
